/**
 * Dismissible notice shown after block removal (single delete, protocol change, or refresh).
 * Informs the user which items were affected and instructs them to update region definitions in the file list.
 */
export default function AffectedItemsNotice({ itemIds = [], onDismiss }) {
    if (!itemIds || itemIds.length === 0) return null;
    const n = itemIds.length;
    return (
        <div
            role="status"
            style={{
                marginBottom: '1em',
                padding: '0.75em 1em',
                background: '#f0f7ff',
                border: '1px solid #b3d4fc',
                borderRadius: 6,
                display: 'flex',
                alignItems: 'flex-start',
                justifyContent: 'space-between',
                gap: '1em',
                flexWrap: 'wrap',
            }}
        >
            <div style={{ flex: 1, minWidth: 0 }}>
                <p style={{ margin: 0, marginBottom: '0.35em', fontWeight: 500 }}>
                    {n} item{n !== 1 ? 's' : ''} {n === 1 ? 'was' : 'were'} assigned to the removed block{n !== 1 ? 's' : ''}.
                </p>
                <p style={{ margin: 0, fontSize: '0.9em', color: '#555' }}>
                    The affected row{n !== 1 ? 's' : ''} {n === 1 ? 'is' : 'are'} highlighted in the file list below. Update region definitions there if needed. Click Done to clear the highlight{n !== 1 ? 's' : ''}.
                </p>
            </div>
            <button
                type="button"
                onClick={onDismiss}
                style={{
                    padding: '0.35em 0.75em',
                    fontSize: '0.9em',
                    cursor: 'pointer',
                    border: '1px solid #ccc',
                    borderRadius: 4,
                    background: '#fff',
                }}
            >
                Done
            </button>
        </div>
    );
}
